import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandLogo from './BrandLogo';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Products', href: '/products' },
    { name: 'Services', href: '/services' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="shadow-lg sticky top-0 z-50" style={{ backgroundColor: '#C0C0C0' }}>
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          {/* Logo with Glass Background */}
          <div className="flex items-center">
            {/* Glass-style background patch for logo */}
            <div className="relative bg-gray-200/90 backdrop-blur-sm rounded-xl px-6 py-4 border border-gray-300 shadow-lg">
              {/* Subtle glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-gray-300 to-transparent rounded-xl"></div>
              
              {/* Logo content */}
              <div className="relative flex items-center space-x-4">
                <img 
                  src="https://static.readdy.ai/image/dc2d8628d8f3138a616830da3589deda/44dc373ebaffdac5e8e9c4a42c13e354.png" 
                  alt="FlameGuardQA Logo" 
                  className="h-12 w-auto object-contain filter drop-shadow-sm"
                  loading="lazy"
                />
                <BrandLogo size="small" className="text-brand-blue" />
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" role="navigation" aria-label="Main navigation">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-gray-800 hover:text-brand-red transition-all duration-300 font-medium whitespace-nowrap cursor-pointer min-h-[44px] flex items-center relative group ${
                  location.pathname === item.href ? 'text-brand-red' : ''
                }`}
                aria-current={location.pathname === item.href ? 'page' : undefined}
              >
                {item.name}
                {/* Subtle hover highlight */}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-brand-red transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-800 hover:text-brand-red transition-colors duration-300 cursor-pointer min-h-[44px] w-[44px] flex items-center justify-center bg-white/80 backdrop-blur-sm rounded-lg border border-gray-200"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isMenuOpen}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <div className="bg-white/95 backdrop-blur-sm rounded-xl border border-gray-200 p-4">
              <nav className="flex flex-col space-y-2" role="navigation" aria-label="Mobile navigation">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`text-gray-800 hover:text-brand-red transition-colors duration-300 font-medium py-3 px-4 cursor-pointer min-h-[44px] flex items-center rounded-lg hover:bg-gray-100 ${
                      location.pathname === item.href ? 'text-brand-red bg-gray-50' : ''
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                    aria-current={location.pathname === item.href ? 'page' : undefined}
                  >
                    {item.name}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
